// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"confirmModal_contentContainer__g9hey","title":"confirmModal_title__o_2e1","content":"confirmModal_content__wdzzD","close":"confirmModal_close__RiaE9"};